import sharedoSettings from "@/services/sharedo/sharedoSettingsService";

const discover = sharedoUrl => new Promise((resolve, reject) => {
    fetch(`${sharedoUrl}api/admin/wordaddin/configuration`, {
        method: "GET",
        cache: "no-cache",
        headers: {
            "Accept": "application/json"
        }
    }).then(response => {
        if (response.ok) {
            resolve(response.json());
        } else {
            reject(response.statusText);
        }
    }, error => reject(error));
});

const getCapabilities = () => new Promise((resolve, reject) => {
    var settings = sharedoSettings.get();

    fetch(`${settings.sharedoApi}api/admin/wordaddin/capabilities`, {
        method: "GET",
        cache: "no-cache",
        headers: {
            "Accept": "application/json"
        }
    }).then(response => {
        if (response.ok) {
            resolve(response.json());
        } else {
            reject(response.statusText);
        }
    }, error => reject(error));
});

export default {
    discover,
    getCapabilities
}